<template>
    <BreadCrumb PageTitle="Retirer des agents d'une file" />
    <RetirerAgent />
</template>

<script lang="ts">

import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import RetirerAgent from "@/components/Affectation/RetirerAgent.vue";


export default defineComponent({
    name: "ListeAffectationPage",
    components: {
        BreadCrumb,
        RetirerAgent,
    },
});
</script>